module.exports = __webpack_public_path__ + "static/powerpods-7c0f8645bfe3d9ebdb4f9c07f185785d.jpg";